module.exports = __webpack_public_path__ + "static/grouping@2x-6854a6b2da2a22e59b3c616a8af271d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/features/design/grouping@2x.png
// module id = 2589
// module chunks = 168707334958949